import httpRequest from "utils/httpRequest";
const URL = "/api";

export const getUserList = async (e_line, cur_page,group_id) => {
  const requestBody = {
    e_line,
    cur_page,
    group_id,
  };
  try {
    const response = await httpRequest("post", `${URL}/userList`, requestBody);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getSellUser = async (user_id) => {
  const requestBody = {
    user_id,
  };
  try {
    const response = await httpRequest("post", `${URL}/getSelUser`, requestBody);
    return response;
  } catch (error) {
    console.error(error);
  }
};

/**
 * 사용자 등록 요청 API //
 * 사용자 등록시 필요한 params
 * @async
 * @function
 * @param {Object} requestBody - Request body object.
 * @param {string} requestBody.user_id - User ID.
 * @param {string} requestBody.fn_password - User password.
 * @param {string} requestBody.fn_name - User name.
 * @param {string} requestBody.fn_group_id - Group ID.
 * @param {number} requestBody.fn_level - User level.
 * @param {string} requestBody.fn_mobile_nbr - Mobile number.
 * @param {string} requestBody.fn_office_nbr - Office telephone number.
 * @param {string} requestBody.fn_address - Address.
 * @param {string} requestBody.fn_address_num - Postal code.
 * @param {string} requestBody.fn_address_detail - Detailed address.
 * @returns {Promise<void>} - Promise object that resolves with no value on success.
 */
export const insertUserInfo = async (data) => {
  const requestBody = {
    user_id: data.user_id,
    fn_password: data.password,
    fn_name: data.fn_name,
    fn_group_id: data.fn_group_nm,
    fn_level: data.fn_level,
    fn_mobile_nbr: data.fn_mobile_nbr,
    fn_office_nbr: "",
    fn_address: data.fn_address ?? "",
    fn_address_num: "",
    fn_address_detail: "",
  };

  try {
    const response = await httpRequest("post", `${URL}/insertUsrInfo`, requestBody);
    return response;
  } catch (error) {
    console.error(error);
  }
};

/**
 * 사용자 업데이트 요청 API //
 * 사용자 업데이트시 필요한 params
 * @async
 * @function
 * @param {Object} requestBody - Request body object.
 * @param {string} requestBody.user_id - User ID.
 * @param {string} requestBody.fn_password - User password.
 * @param {string} requestBody.fn_name - User name.
 * @param {string} requestBody.fn_group_id - Group ID.
 * @param {number} requestBody.fn_level - User level.
 * @param {string} requestBody.fn_mobile_nbr - Mobile number.
 * @param {string} requestBody.fn_office_nbr - Office telephone number.
 * @param {string} requestBody.fn_address - Address.
 * @param {string} requestBody.fn_address_num - Postal code.
 * @param {string} requestBody.fn_address_detail - Detailed address.
 * @returns {Promise<void>} - Promise object that resolves with no value on success.
 */
export const updateUserInfo = async (data) => {
  const requestBody = {
    user_id: data.user_id,
    fn_password: data.password,
    fn_name: data.fn_name,
    fn_group_id: data.fn_group_id,
    fn_level: data.fn_level,
    fn_mobile_nbr: data.fn_mobile_nbr,
    fn_office_nbr: "",
    fn_address: data.fn_address,
    fn_address_num: "",
    fn_address_detail: "",
  };

  try {
    const response = await httpRequest("post", `${URL}/updateUsrInfo`, requestBody);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const requestNewPassword = async (data) => {
  const requestBody = {
    user_id: data.user_id,
    fn_password: data.password,
    fn_name: data.fn_name,
    fn_group_id: data.fn_group_id,
    fn_level: data.fn_level,
    fn_mobile_nbr: data.fn_mobile_nbr,
    fn_office_nbr: "",
    fn_address: data.fn_address,
    fn_address_num: "",
    fn_address_detail: "",
    req_newPassword: "reqNew",
  };

  try {
    const response = await httpRequest("post", `${URL}/requestNewPassword`, requestBody);
    return response;
  } catch (error) {
    console.error(error);
  }
};

/**
 *
 * User Info Delete API
 */
export const deleteUserInfo = async (user_id) => {
  const requestBody = {
    user_id,
  };
  try {
    const response = await httpRequest("post", `${URL}/delUsrInfo`, requestBody);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getCombo = async () => {
  try {
    const response = await httpRequest("post", `${URL}/getCombo`);
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getPopupUser = async (fn_group_id) => {
  try {
    const response = await httpRequest("post", `${URL}/popUsr`, {
      fn_group_id,
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};
